import PropTypes from 'prop-types';
import React from 'react'
import { findDOMNode } from 'react-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { animateScroll } from 'react-scroll'
import ReactTooltip from 'react-tooltip'

import { Icon } from '~/components'
import SocialIcons from './SocialIcons'

import { toggleArticleBookmark, toggleArticleFlare, shareArticleToCamp } from '~/actions/article'


class Actions extends React.Component {
    static propTypes = {
		sessionCamps: PropTypes.array,
		articleID: PropTypes.number.isRequired,
		bookmarked: PropTypes.string,
		bookmarks: PropTypes.number,
		comment_count: PropTypes.number,
		link: PropTypes.string,
		flared: PropTypes.string,
		flares: PropTypes.number,
		sessionUser: PropTypes.oneOfType([
			PropTypes.bool,
			PropTypes.object
		]),
		title: PropTypes.string.isRequired
	};

    bookmark = () => {
		this.props.toggleArticleBookmark(this.props.articleID)
	};

    flare = () => {
		this.props.toggleArticleFlare(this.props.articleID)
	};

    jumpToComments = (event) => {
		event.preventDefault();
		animateScroll.scrollToBottom();
	};

    shareToCamp = (e) => {
		e.preventDefault();
		let campID = this.refs.shareCamp.value;
		let statement = this.refs.shareStatement.value;
		if( !campID ) return;
		this.props.shareArticleToCamp(this.props.articleID, campID, statement)
		ReactTooltip.hide(findDOMNode(this.refs.triggerTooltip))
	};

    render() {

		return (
			<div>

				<SocialIcons />

				<p className="text-left ptop30 pbot30">

					<span className={"large mright30" + (this.props.sessionUser ? ' clickable' : '')} onClick={this.props.sessionUser ? this.flare : false}>
						<Icon icon={'flares'} className={!!this.props.flared ? 'text-mid-danger' : 'text-dark-gray'} />
						<text className="small"> { this.props.flares }</text>
					</span>
					<span className={"large mright30" + (this.props.sessionUser ? ' clickable' : '')} onClick={this.props.sessionUser ? this.bookmark : false}>
						<Icon icon={'bookmarks'} className={!!this.props.bookmarked ? 'text-mid-success' : 'text-dark-gray'} />
						<text className="small"> { this.props.bookmarks }</text>
					</span>
					<span className="large clickable" onClick={this.jumpToComments}>
						<Icon icon={'comments'} className={'text-dark-gray'} />
						<text className="small"> { this.props.comment_count }</text>
					</span>

					{ !!this.props.sessionUser && !!this.props.sessionUser.verified_email &&
						<span className="pull-right clickable">
							<a data-for='getContent' className="btn btn-primary" data-tip="custom show" data-event='click focus' ref='triggerTooltip'>Share to Camp</a>
						</span>
					}

	        	</p>

				{ !!this.props.sessionUser && 
					<ReactTooltip place="bottom" id='getContent' class="camp-tooltip" type="light" border offset={{left: 111}} effect="solid">
						<form onSubmit={this.shareToCamp} className="narrow-gutter">
							<p className="mbot10">Share your thoughts on the article</p>
							<textarea className="form-control mbot10" ref='shareStatement' />
							<div className="row">
								<div className="col-xs-9">
									<select ref="shareCamp" className="form-control">
										{ this.props.sessionCamps.map( function(camp) {
											return <option key={'share-to-camp-'+camp.slug} value={camp.ID}>{camp.title}</option>
										}, this ) }
									</select>
								</div>
								<div className="col-xs-3">
									<button className="btn btn-primary btn-block" type="submit">Share</button>
								</div>
							</div>
						</form>
					</ReactTooltip>
				}

			</div>
		)
	}
}

const mapStateToProps = state => ({
    sessionUser: state.session.user,
    sessionCamps: state.session.camps,
});

const mapDispatchToProps = dispatch => bindActionCreators({ toggleArticleBookmark, toggleArticleFlare, shareArticleToCamp }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Actions);



// WEBPACK FOOTER //
// ./src/js/views/Article/components/Actions.js